import { create } from 'zustand';

// Tiny shared store so both the sidebar (ConsoleLayout) and the Dashboard can
// open the single WalletModal that is mounted once at the layout root.
interface WalletModalState {
  open: boolean;
  show: () => void;
  hide: () => void;
}

export const useWalletModal = create<WalletModalState>((set) => ({
  open: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
}));
